<template>
  <div id="goodsPurchaseReturnDetail">
    <div class="invoicingHead" style="height:40px;">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a
            @click="jumpTT('/invoicingFather/goodsPurchaseReturn')"
            href="javascript:;"
            >进货退货单管理</a
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item>进货退货单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="invoicingHeadDown">
      <!-- 进货退货单详情资料 -->
      <div class="goodsDetail">
        <div>进货退货详情</div>
        <div class="info">
          <div class="first" style="width: 15%">
            <div>单号：{{ list.orderCode }}</div>
            <div>业务日期：{{ list.businessTime }}</div>
            <div>经手人：{{ list.handlerName }}</div>
            <div>供应商：{{ list.supplierName }}</div>
          </div>
          <div style="width: 15%;padding-left:25px;box-sizing:border-box;">
            <div>出库仓库：{{ list.repositoryName }}</div>
            <div>其它费用：￥{{ list.otherFree }}</div>
            <div>本单应退：￥{{ list.accountRefundPayable }}</div>
            <div>结算账户：{{ list.settlementMethod == 1 ? "现金" : "" }}</div>
          </div>
          <div style="width: 25%;padding-right: 20px;box-sizing:border-box;">
            <div>实退金额：￥{{ list.accountRefundPayable }}</div>
            <div>
              整单备注：{{ list.refundRemark == "" ? "无" : list.refundRemark }}
            </div>
          </div>
          <div style="width: 40%">
            <div>图片附件：</div>
            <div>
              <el-upload
                action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :http-request="loadImg"
                :show-file-list="true"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :class="{ hide: hideUpload }"
                :limit="3"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
          <div style="width: 15%">
            <el-button
              type="primary"
              plain
              size="small"
              @click="voucherDialogVisible = true"
              >查看单据</el-button
            >
            <el-button
              type="primary"
              v-if="isDestroy == 0"
              size="small"
              @click="destroyRefundGoods"
              >作废</el-button
            >
            <!-- <div v-if="isDestroy == 1" style="font-weight:bold;font-size:23px;">已作废</div> -->
          </div>
        </div>
      </div>
      <div class="title">退货商品</div>
      <!-- 表格 -->
      <div style="width: calc(100vw - 250px);">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            align="center"
            prop="goodsName"
            label="退货商品"
            width="180"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="valueContent"
            label="规格"
          ></el-table-column>
          <el-table-column align="center" prop="takePrice" label="进货价">
            <template slot-scope="scope">
              ￥{{ scope.row.takePrice }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsUnit"
            label="单位"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="goodsNum"
            label="数量"
          ></el-table-column>
          <el-table-column align="center" prop="outStorageStatus" label="状态">
            <template slot-scope="scope">
              <div
                style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #6ABCF8;margin:auto;color:#6ABCF8;font-size:10px;"
                v-if="isDestroy == 0"
              >
                全部出库
              </div>
              <div
                style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #ccc;margin:auto;color:#ccc;font-size:10px;"
                v-if="isDestroy == 1"
              >
                作废
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="totalTakePrice" label="总价">
            <template slot-scope="scope">
              ￥{{ scope.row.totalTakePrice.toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="queryInfo.pageNum"
                    :page-size="queryInfo.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  ></el-pagination>
                </div> -->
      </div>
    </div>
    <!-- 单据 -->
    <el-dialog
      :visible.sync="voucherDialogVisible"
      width="16%"
      :before-close="handleVoucherClose"
    >
      <span>
        <div class="shopName">{{ shopInformation.shopName }}</div>
        <div class="voucherTitle shopName mb20">
          <span class="line"></span>
          <span>进货退货单</span>
          <span class="lines"></span>
        </div>
        <div class="dottedLine"></div>
        <div class="dottedLine"></div>
        <div class="mt20 mb20">
          <div class="mb5">入库仓库：{{ list.repositoryName }}</div>
          <div class="mb5">供应商：{{ list.supplierName }}</div>
          <div class="mb5">经手人：{{ list.handlerName }}</div>
          <div class="mb5">单号：{{ list.orderCode }}</div>
          <div>日期：{{ list.businessTime }}</div>
          <div v-if="isDestroy == 1" style="font-weight:bold;font-size:23px;">
            进货退货单：已作废
          </div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mb5">商品名称/规格</div>
        <div class="flex-betweens">
          <div class="mb5" style="width: 23%;text-align: left;">单价(元)</div>
          <div class="mb5" style="width: 25%;text-align: center;">
            数量/单位
          </div>
          <div class="mb5" style="width: 23%;text-align: right;">合计(元)</div>
        </div>
        <div
          class="flex-between"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div class="mb5" style="width: 35%;">
            {{ item.goodsName }}/{{ item.valueContent }}
          </div>
          <div class="flex-betweens mb5">
            <div style="width: 30%;text-align: left;">{{ item.takePrice }}</div>
            <div style="width: 30%;text-align: center;">
              {{ item.goodsNum }}/{{ item.goodsUnit }}
            </div>
            <div class="mb5" style="width: 30%;text-align: right;">
              {{ (item.goodsNum * item.takePrice).toFixed(2) }}
            </div>
          </div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mt20 mb20">
          <div class="flex-betweens">
            <div class="mb5">合计：{{ totalLength }}</div>
            <div class="mb5">
              ￥{{ (list.accountRefundPayable - list.otherFree).toFixed(2) }}
            </div>
          </div>
          <div class="mb5">其它费用：￥{{ list.otherFree }}</div>
          <div>结算账户：现金</div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mb20">
          <div class="mb5">应付金额：￥{{ list.accountRefundPayable }}</div>
          <div class="mb5">实付金额：￥{{ list.accountRefundPayable }}</div>
          <div>备注：{{ list.refundRemark ? list.refundRemark : "无" }}</div>
        </div>
        <div class="dottedLine"></div>
        <div class="dottedLine"></div>
        <div class="shopName mt20">谢谢惠顾！</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { uploadImg, singleReturnGoodsList, destroyRefundGoods } from "../api";
export default {
  data() {
    return {
      shopInformation: {},
      userList: {},
      dialogVisible: false,
      dialogImageUrl: "",
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 999
      },
      orderId: "",
      isDestroy: "",
      voucherDialogVisible: false,
      list: {
        orderCode: "",
        businessTime: "",
        handlerName: "",
        supplierName: "",
        repositoryName: "",
        otherFree: "",
        accountRefundPayable: "",
        refundRemark: "",
        settlementMethod: "",
        goodsName: "",
        totalTakePrice: "",
        takePrice: ""
      },
      totalLength: 0,
      loading: false,
      fileList: [],
      hideUpload: false
    };
  },
  created() {
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    console.log(shopInformation, userList);
    this.shopInformation = shopInformation;
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.orderId = this.$route.query.orderId;
    this.isDestroy = this.$route.query.isDestroy;
    this.getSingleReturnGoodsList();
    this.hideUpload = true;
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 图片放大
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isPNG) {
        this.$message.error("上传图片只能是 PNG 格式!");
      }
      return isJPG || isPNG;
    },
    // 上传商品图片
    loadImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.dialogImageUrl = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    // 获取退货进货单详情列表
    getSingleReturnGoodsList() {
      this.loading = true;
      singleReturnGoodsList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNum,
        row: this.queryInfo.pageSize,
        orderId: this.orderId
      }).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.productJson;
          this.list = res.data;
          var imgList = res.data.photoAppendix.split(",");
          console.log(imgList, "imgList");
          imgList.forEach(item => {
            if (item) {
              this.fileList.unshift({ name: "", url: item });
            }
          });
          this.tableData.forEach(element => {
            this.totalLength += Number(element.goodsNum);
            // this.fileList.unshift({name: "", url: element.goodsImage})
          });
          for (var i = 0; i < this.tableData.length; i++) {
            this.list.goodsName = this.tableData[i].goodsName;
            this.list.takePrice = this.tableData[i].takePrice;
            this.list.totalTakePrice = this.tableData[i].totalTakePrice;
          }
          this.list.accountRefundPayable = this.list.accountRefundPayable
            ? this.list.accountRefundPayable.toFixed(2)
            : "";
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分页
    // handleCurrentChange(newVal) {

    // },
    // handleSizeChange(newVal) {

    // }
    // 作废
    destroyRefundGoods() {
      this.$confirm("是否确定作废", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          destroyRefundGoods({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            isManager: 1,
            orderId: this.orderId
          }).then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.$router.push("/invoicingFather/goodsPurchaseReturn");
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleVoucherClose() {
      this.voucherDialogVisible = false;
    }
  }
};
</script>

<style scoped>
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.flex-betweens {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.flex-between {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flex-between:last-child {
  text-align: right;
}
.mb5 {
  margin-bottom: 5px;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.dottedLine {
  border: 1px dotted #ccc;
  margin-top: 5px;
}
.dashedLine {
  border: 1px dashed #ccc;
  margin-top: 5px;
}
.line {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  top: 111px;
}
.lines {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  left: 195px;
  top: 111px;
}
.shopName {
  font-size: 18px;
  text-align: center;
  color: #000;
}
.voucherTitle {
  padding-top: 15px;
  font-size: 18px;
}
.goodsDetail {
  width: calc(100vw - 280px);
  height: auto;
  background-color: #f8f8f8;
  padding: 20px;
}
.info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #737373;
}
.title {
  width: calc(100vw - 245px);
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
  background-color: #f8f8f8;
  font-size: 15px;
  padding-left: 20px;
  box-sizing: border-box;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
  margin-top: 20px;
}
</style>
<style>
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
  margin-top: 10px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
  margin-top: 10px;
}
/* .el-table th {
    background-color: #F2F3F2;
    margin-top: 20px;
} */
.el-dialog__headerbtn .el-dialog__close {
  display: none;
}
</style>
<style>
.hide .el-upload--picture-card {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/page/goodsPurchaseReturnDetail.vue